(() => {
  if (window.grawrPremiumLoaded) return;
  window.grawrPremiumLoaded = true;
  const init = (scope) => {
    scope.querySelectorAll('[data-premium-home]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const steps = root.querySelectorAll('[data-gp-step]');
      steps.forEach(step => step.addEventListener('toggle', () => {
        if (!step.open) return;
        steps.forEach(other => { if (other !== step) other.open = false; });
        root.querySelectorAll('[data-gp-frame]').forEach(frame => {
          frame.hidden = frame.dataset.gpFrame !== step.dataset.gpStep;
        });
      }));
      if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('gp-enter'); observer.unobserve(entry.target); }
        }), { threshold: 0.12 });
        root.querySelectorAll('[data-gp-reveal]').forEach(item => observer.observe(item));
        root._gpObserver = observer;
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-premium-home]').forEach(root => root._gpObserver?.disconnect());
  });
})();
